import { Component, inject, input } from '@angular/core';

import { fullName } from '@camelot/utils';

import { CommunicationParticipantExtended } from '../../../../../services/dto/communication';
import { CamSharedCommunicationsService } from '../../../../../services/shared.service';
import { CamTranslationCommunication } from '../../../../../translation.service';

@Component({
  host: { 'data-cid': 'switch-case-base' },
  selector: '',
  template: '',
  standalone: true,
})
export class SwitchCaseBaseComponent<T> {
  case = input.required<T>();

  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  readonly Number = Number;
  readonly fullName = fullName;
  readonly sharedService = inject(CamSharedCommunicationsService);

  constructor() {
    CamTranslationCommunication.getInstance();
  }

  public getConversationParticipant(id: string) {
    const find = this.conversationParticipants().find(p => {
      if (p.userId === id) {
        return true;
      }
      if (p.contactId === id) {
        return true;
      }
      return false;
    });

    if (!find) {
      return fullName({ firstName: '', name: '' });
    }
    if (find.user) {
      return fullName({
        firstName: find.user.firstName,
        name: find.user.lastName,
      });
    }
    if (find.contact) {
      return fullName({
        firstName: find.contact.firstName,
        name: find.contact.lastName,
      });
    }
    return fullName({ firstName: '', name: '' });
  }
}
